import enDefaults from './en'

export default {
  ...enDefaults,
}
